export const track = (props, options, cb) => {
  let vwoObject = {};
  if (Object.keys(window._CURRENT_CAMPAIGNS_EW_VWO ?? {}).length > 0) {
    vwoObject = window._CURRENT_CAMPAIGNS_EW_VWO;
  }
  if (window && window.freshpaint) {
    window.freshpaint.track(
      props.event,
      { ...props.data, ...vwoObject },
      options,
      cb,
    );
  }
};

export default track;
